module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "Title",
    attrs: {
      "id": "heading_id_3"
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Who You Are When No One’s Looking")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("Choosing Consistency,"), _c('br'), _vm._v("\n  Resisting Compromise")]), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n  Revised and Expanded")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Bill Hybels")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Edited by LaVonne Neff"), _c('br'), _vm._v("\n  Revised edition edited by Ashley Wiersma")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('img', {
    attrs: {
      "alt": "IVP Books",
      "src": "Images/IVP_Books_Half.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ceaacd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/titlepage.vue
// module id = 57
// module chunks = 0